import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "filter__list filter-doctype__list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "filter-doctype__check iconfont icheck-bold",
  "aria-hidden": "true"
}

import { ref } from 'vue'

import type { DocsView } from '@/models/doc'
import { DocsFilterTypeView } from '@/models/docs.filter'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocsFilterType',
  props: {
    view: {},
    newStyle20321B: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const typeSelectView = ref(new DocsFilterTypeView(props.view))

function hide(): void {
  assertNotNull(typeSelectView.value).hide()
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter__order filter-doctype", {
      'filter__order--active': typeSelectView.value.visible,
      'filter-doctype--20321B': __props.newStyle20321B,
    }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (typeSelectView.value.toggleMenu()))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "filter__active" }, "Content Types", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "filter__arr iconfont iarrow-down" }, null, -1)),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeSelectView.value.options, (opt) => {
            return (_openBlock(), _createElementBlock("li", {
              key: opt.name,
              class: "filter__item filter-doctype__item",
              onClick: _withModifiers(($event: any) => (opt.click()), ["prevent","stop"])
            }, [
              _createElementVNode("span", null, _toDisplayString(opt.name), 1),
              (opt.isActive())
                ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                : _createCommentVNode("", true)
            ], 8, _hoisted_2))
          }), 128))
        ], 512), [
          [_vShow, typeSelectView.value.visible]
        ])
      ]),
      _: 1
    })
  ], 2)), [
    [_directive_click_outside, hide]
  ])
}
}

})